import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {HttpProvider} from "../http/http";

/*
  Generated class for the EssenceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class EssenceProvider {

  constructor(public http: HttpProvider) {
    console.log('Hello EssenceProvider Provider');
  }

  getEssences(page,pagesize){
    return this.http.hPost('/essence/list',{page:page,pagesize:pagesize});
  }

  getRecord(start,end,chatroonmname,page,pagesize){
    let params = {
      start_dt:start,
      end_dt:end,
      chatroomname:chatroonmname,
      page:page,
      pagesize:pagesize
    }
    return this.http.hPost('/essence/record',params);
  }

  getSetting(uuid){
    return this.http.hPost('/essence/get_settings',{uuid:uuid});
  }

  getEssenceDetail(uuid,page,pagesize){
    return this.http.hPost('/essence/detail',{uuid:uuid,page:page,pagesize:pagesize});

  }

  createSetting(chatroomname,msg_list,cover_img,title,desc,start_dt,end_dt,uuid){
    let params = {
      chatroomname:chatroomname,
      msg_list:msg_list,
      cover_img:cover_img,
      title:title,
      desc:desc,
      start_dt:start_dt,
      end_dt:end_dt
    }
    if(uuid){
      params['uuid'] = uuid
    }
    return this.http.hPost('/essence/settings',params);
  }

  getEssenceVoice(uuid,msg_id){
    return this.http.hPost('/essence/voice',{uuid:uuid,msg_id:msg_id});
  }

  deleteEssence(uuid,page,pagesize){
    return this.http.hPost('/essence/del_settings',{uuid:uuid,page:page,pagesize:pagesize});
  }
}



// WEBPACK FOOTER //
// ./src/providers/essence/essence.ts